<template>
  <div>
    <b-modal id="modal-detailprod" hide-footer centered title=" " ref="currMe" width="700px">
      <div>
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <!-- Slides with image only -->
          <b-carousel-slide v-for="(pic, index) in product.photos" :img-src="pic" :key="index"></b-carousel-slide>
        </b-carousel>
      </div>
      <barcode
        :value="'('+product.id+') '+product.price+'DT'"
        :options="{ lineColor: '#0275d8', text: 'Scan'}"
      ></barcode>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "ModalDetailProduit",
  data() {
    return {
      product: {
        photos: []
      },
      slide: 0,
      value: "",
      tag: "svg",
      options: {
        lineColor: "#ff7069",
        fontSize: 32,
        font: "Courier",
        width: 3,
        height: 60,
        marginBottom: 60,
        format: "MSI",
        background: "#ccffff"
      }
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    showDetails(product) {
      this.product = product;
      this.$refs.currMe.show();
    }
  }
};
</script>
<style lang="scss">
.modal-body {
  display: flex;
  flex-flow: column;
  // width: 700px;
}
.img-fluid {
  width: 100% !important;
  height: 400px !important;
}
</style>
                        